import { generateStackedChartData } from '@/components/chart/utils';
import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { NormalTable } from '@/components/data-table/normal-table';
import {
  useDashboardOverview,
  useDashboardReservationPlanAnalytics,
  useDashboardTopAffiliateRanks,
} from '@/features/dashboard/hooks/useDashboardOverview';
import OverviewInfoCard from '@/features/dashboard/overview/overviewInfoCard';
import { OverViewSalesBreakdown } from '@/features/dashboard/overview/overviewSales';
import { DashboardIcon } from '@/icons';
import { InfoCard, SalesItem } from '@/services/dashboard/overview/overview.types';
import { createFileRoute } from '@tanstack/react-router';
import { ColumnDef } from '@tanstack/react-table';
import { Calendar } from 'lucide-react';

export const Route = createFileRoute('/(app)/dashboard/overview')({
  loader: () => {
    return {
      crumb: <CrumbTitle title="Overview" icon={DashboardIcon} />,
      title: 'Overview',
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { overview } = useDashboardOverview();
  const { reservationPlanAnalytics } = useDashboardReservationPlanAnalytics();
  const { topAffiliateRanks } = useDashboardTopAffiliateRanks();
  const days = ['月', '火', '水', '木', '金', '土', '日'];

  const dataset = generateStackedChartData(days, reservationPlanAnalytics);
  const categoryMeta = reservationPlanAnalytics.map(({ key, name, color }) => ({
    key,
    name: name,
    color: color,
  }));

  const icons = [Calendar, Calendar, Calendar, Calendar, Calendar];
  const dashboardSummaryData = overview.map((item: InfoCard, index) => {
    const icon = icons[index];
    const action: { label: string; link: string } | undefined =
      item.title === "Today's Reservation" || item.title === "Tomorrow's Reservation"
        ? { label: '詳細', link: '/' }
        : undefined;
    return {
      ...item,
      icon,
      action,
    };
  });

  const columns: ColumnDef<SalesItem>[] = [
    {
      accessorKey: 'id',
      header: '',
    },
    {
      accessorKey: 'noOfReservation',
      header: 'No. of Reservations',
    },

    {
      accessorKey: 'noOfStore',
      header: 'No. of Store',
    },
    {
      accessorKey: 'noOfAffiliate',
      header: 'No. of Affiliates',
    },
    {
      accessorKey: 'receivedAmount',
      header: 'Received Amount',
    },
  ];

  const data: SalesItem[] = [
    {
      id: 'This Week’s',
      noOfReservation: '20',
      noOfAffiliate: '110',
      noOfStore: '40',
      receivedAmount: '450000',
    },
    {
      id: 'This Month’s',
      noOfReservation: '20',
      noOfAffiliate: '110',
      noOfStore: '40',
      receivedAmount: '450000',
    },
    {
      id: 'Last 3 Month’s',
      noOfReservation: '20',
      noOfAffiliate: '110',
      noOfStore: '40',
      receivedAmount: '450000',
    },
    {
      id: 'Last 6 Month’s',
      noOfReservation: '20',
      noOfAffiliate: '110',
      noOfStore: '40',
      receivedAmount: '450000',
    },
    {
      id: 'This Year’s',
      noOfReservation: '20',
      noOfAffiliate: '110',
      noOfStore: '40',
      receivedAmount: '450000',
    },
  ];

  return (
    <>
      <OverviewInfoCard dashboardSummaryData={dashboardSummaryData} />
      <OverViewSalesBreakdown
        topAffiliateRanks={topAffiliateRanks}
        dataset={dataset}
        categoryMeta={categoryMeta}
        data={data}
      />
      <NormalTable columns={columns} data={data} className="my-0" />
    </>
  );
}
